/* loaded by smart-asset */
export default require("./42a~mxbCPNhT.svg")